import styled, { keyframes, css } from 'styled-components';
import { EnrollmentCardContainer, ImageColumn, ContentColumn, MetaColumn } from '../EnrollmentCard.style';
const shimmer = keyframes `
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
`;
const skeletonAnimation = css `
  background: #e2e2e2;
  background-image: linear-gradient(
    to right,
    #e2e2e2 0%,
    #d1d1d1 20%,
    #e2e2e2 40%,
    #e2e2e2 100%
  );
  background-repeat: no-repeat;
  background-size: 800px 104px;
  animation: ${shimmer} 1s linear infinite forwards;
`;
export const SkeletonContainer = styled(EnrollmentCardContainer) `
  pointer-events: none;
`;
export const SkeletonImage = styled(ImageColumn) `
  ${skeletonAnimation}
  background-size: 800px 100%;
`;
export const SkeletonContent = styled(ContentColumn) `
  gap: 16px;
`;
export const SkeletonTag = styled.div `
  width: 100px;
  height: 24px;
  border-radius: 4px;
  ${skeletonAnimation}
`;
export const SkeletonTitle = styled.div `
  width: 80%;
  height: 32px;
  border-radius: 4px;
  ${skeletonAnimation}
`;
export const SkeletonDescription = styled.div `
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
export const SkeletonLine = styled.div `
  width: ${({ width }) => width || '100%'};
  height: 16px;
  border-radius: 4px;
  ${skeletonAnimation}
`;
export const SkeletonMeta = styled(MetaColumn) `
  gap: 16px;
`;
export const SkeletonMetaInfo = styled.div `
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
export const SkeletonMetaLine = styled.div `
  width: 100%;
  height: 14px;
  border-radius: 4px;
  ${skeletonAnimation}
`;
export const SkeletonProgress = styled.div `
  width: 100%;
  height: 40px;
  border-radius: 4px;
  ${skeletonAnimation}
  margin-top: auto;
`;
export const SkeletonButtons = styled.div `
  display: flex;
  gap: 12px;
  margin-top: 16px;
`;
export const SkeletonButton = styled.div `
  flex: 1;
  height: 40px;
  border-radius: 4px;
  ${skeletonAnimation}
`;
//# sourceMappingURL=EnrollmentCardSkeleton.style.js.map